module.exports = __webpack_public_path__ + "img/浦发银行@2x.f02bcca9.png";